module.exports = __webpack_public_path__ + "img/live_icon.7db347b0.svg";